'use strict';

const Enum = require('./enum');

/**
 * Defines bridge event types.
 * Maps to bridge_event_types in
 * PostgreSQL database.
 *
 * @enum
 * @readonly
 */
const BridgeEventTypes = Object.create(Enum, {
  ONLINE: { value: 1, enumerable: true },
  OFFLINE: { value: 2, enumerable: true },
  REMOTE_OPERATION: { value: 3, enumerable: true },
});

exports.BridgeEventTypes = BridgeEventTypes;
